var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCashPayment6401(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 39.171 33.76 l 4.964 -22.019 c 0.441 -1.99 -0.619 -4.007 -2.507 -4.774 l 0 0 c -1.999 -0.812 -4.306 0.022 -5.28 1.947 c -7.493 14.812 -20.942 32.629 -20.942 39.459 c -0.027 0.354 -0.039 0.708 -0.039 1.061 c 0 3.091 0.954 6.144 1.879 9.106 c 1.016 3.251 2.066 6.611 1.817 9.941 l -0.615 8.247 l 20.317 0 C 35.759 62.717 35.703 48.413 39.171 33.76 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(238,198,179)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 39.409 8.993 c -7.493 15.33 -20.942 33.771 -20.942 40.839 c -0.027 0.366 -0.039 0.733 -0.039 1.098 c 0 3.199 0.954 6.359 1.879 9.425 c 1.016 3.365 2.066 6.842 1.817 10.288 l -0.438 6.084 h -3.237 l 0.615 -8.247 c 0.248 -3.33 -0.802 -6.69 -1.817 -9.941 c -0.925 -2.963 -1.879 -6.015 -1.879 -9.106 c 0 -0.353 0.012 -0.707 0.039 -1.061 c 0 -6.829 13.449 -24.647 20.942 -39.459 c 0.968 -1.914 3.256 -2.746 5.247 -1.957 C 40.677 7.325 39.883 8.022 39.409 8.993 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(205,149,123)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 75.268 11.483 c -7.013 14.382 -9.524 28.226 -9.856 46.061 L 37.67 56.562 c 0.137 -16.69 2.579 -32.098 10.13 -46.674 c 0.365 -0.705 1.112 -1.132 1.905 -1.104 L 74.16 9.65 C 75.082 9.683 75.673 10.654 75.268 11.483 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(34,105,38)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 65.786 4.576 c -2.468 17.262 -2.723 34.796 -0.558 52.628 l -27.609 2.883 c -2.175 -16.481 -1.514 -34.247 0.615 -52.678 c 0.114 -0.984 0.899 -1.758 1.884 -1.861 l 24.181 -2.525 C 65.183 2.932 65.912 3.696 65.786 4.576 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(39,119,44)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 55.82 1.551 l 10.459 55.97 c 0.193 1.032 -0.487 2.024 -1.519 2.217 l -26.966 5.039 c -1.032 0.193 -2.024 -0.487 -2.217 -1.519 L 25.118 7.288 c -0.193 -1.032 0.487 -2.024 1.519 -2.217 l 26.966 -5.039 C 54.635 -0.16 55.627 0.52 55.82 1.551 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(49,139,54)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 28.792 12.82 l 8.212 43.945 c 3.072 -0.574 6.028 1.451 6.602 4.523 l 14.505 -2.71 c -0.574 -3.072 1.451 -6.028 4.523 -6.602 L 54.422 8.03 c -0.055 0.012 -0.108 0.029 -0.165 0.039 c -3.072 0.574 -6.028 -1.451 -6.602 -4.523 l -14.505 2.71 C 33.714 9.273 31.77 12.171 28.792 12.82 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(59,158,65)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.117000000000004,
    cy: 60.687000000000005,
    r: 1.417,
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(59,158,65)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "  matrix(1 0 0 1 0 0) "
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 62.017,
    cy: 56.407000000000004,
    r: 1.417,
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(59,158,65)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "  matrix(1 0 0 1 0 0) "
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29.377000000000002,
    cy: 8.407,
    r: 1.417,
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(59,158,65)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "  matrix(1 0 0 1 0 0) "
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 52.277,
    cy: 4.127,
    r: 1.417,
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(59,158,65)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "  matrix(1 0 0 1 0 0) "
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45.695,
    cy: 32.405,
    r: 11.135,
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(49,139,54)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "  matrix(1 0 0 1 0 0) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 46.093 28.513 c -1.156 0.844 -1.463 2.455 -1.601 3.764 c -0.166 1.572 -0.489 1.964 -0.62 2.06 c -0.085 0.062 -0.242 0.07 -0.428 0.032 c -0.537 -0.129 -1.005 -0.714 -1.137 -1.421 c -0.095 -0.508 -0.005 -1.021 0.222 -1.385 c 0.167 -0.269 0.144 -0.614 -0.036 -0.875 l -0.473 -0.682 c -0.313 -0.451 -0.983 -0.486 -1.32 -0.053 c -0.514 0.66 -0.809 1.502 -0.844 2.4 l -0.88 0.164 c -0.447 0.084 -0.742 0.514 -0.658 0.961 l 0.143 0.764 c 0.084 0.447 0.514 0.742 0.961 0.658 l 0.974 -0.182 c 0.54 1.01 1.435 1.756 2.52 2.017 c 1.15 0.238 1.934 -0.108 2.388 -0.44 c 1.156 -0.844 1.463 -2.455 1.601 -3.764 c 0.165 -1.573 0.488 -1.965 0.62 -2.061 c 0.085 -0.062 0.242 -0.07 0.429 -0.032 c 0.537 0.129 1.005 0.714 1.137 1.422 c 0.095 0.509 0.006 1.02 -0.221 1.385 c -0.167 0.269 -0.144 0.614 0.036 0.874 l 0.473 0.682 c 0.316 0.456 0.989 0.481 1.33 0.044 c 0.477 -0.613 0.766 -1.383 0.831 -2.209 l 0.915 -0.171 c 0.447 -0.084 0.742 -0.514 0.658 -0.961 l -0.143 -0.764 c -0.084 -0.447 -0.514 -0.742 -0.961 -0.658 l -0.916 0.171 c -0.528 -1.095 -1.467 -1.905 -2.611 -2.18 C 47.332 27.835 46.548 28.181 46.093 28.513 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(59,158,65)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 49.573 46.709 l 1.019 5.453 c 0.12 0.641 -0.303 1.258 -0.944 1.378 l 0 0 c -0.641 0.12 -1.258 -0.303 -1.378 -0.944 l -1.019 -5.453 c -0.12 -0.641 0.303 -1.258 0.944 -1.378 h 0 C 48.836 45.646 49.453 46.068 49.573 46.709 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(49,139,54)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 43.127 12.213 l 1.019 5.453 c 0.12 0.641 -0.303 1.258 -0.944 1.378 h 0 c -0.641 0.12 -1.258 -0.303 -1.378 -0.944 l -1.019 -5.453 c -0.12 -0.641 0.303 -1.258 0.944 -1.378 v 0 C 42.39 11.149 43.007 11.572 43.127 12.213 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(49,139,54)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 49.663 35.15 c 1.758 2.354 3.405 5.857 1.204 10.722 l -6.253 13.521 c -0.785 2.157 -0.592 4.288 -0.385 6.546 c 0.222 2.413 0.449 4.918 -0.528 7.535 l -1.573 4.226 l -10.604 -3.07 C 29.441 59.548 43.72 37.118 49.663 35.15 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(238,198,179)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 34.355 56.9 c 1.173 -8.285 7.047 -16.95 12.261 -21.777 c 0.862 -0.798 2.199 -0.785 3.048 0.027 l 0 0 C 46.414 35.312 38.23 48.864 34.355 56.9 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(205,149,123)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 14.602 75.091 v 12.324 c 0 1.427 1.157 2.585 2.585 2.585 h 30.557 c 1.427 0 2.585 -1.157 2.585 -2.585 V 75.091 c 0 -1.427 -1.157 -2.585 -2.585 -2.585 H 17.187 C 15.76 72.507 14.602 73.664 14.602 75.091 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(52,57,54)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 50.329 75.091 v 1.27 c -0.096 -0.011 -0.19 -0.029 -0.289 -0.029 H 19.482 c -1.427 0 -2.585 1.157 -2.585 2.585 v 11.054 c -1.289 -0.145 -2.295 -1.227 -2.295 -2.555 V 75.091 c 0 -1.427 1.157 -2.585 2.585 -2.585 h 30.557 C 49.172 72.507 50.329 73.664 50.329 75.091 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(46,50,47)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCashPayment6401);
export default __webpack_public_path__ + "static/media/cash-payment-6401.1f304287bc4f73556528cd7f3dbb879e.svg";
export { ForwardRef as ReactComponent };